import { TrashIcon } from "@heroicons/react/24/solid";
import { Col, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { Input, Textarea } from "stories";

const MemberItem = ({ memberIndex, index, onRemove }) => {
  const form = useFormContext();

  return (
    <>
      <Row>
        <Col>
          <Input
            label={"Name"}
            {...form.register(
              `projectMembers[${memberIndex}].members[${index}].name`
            )}
          />
        </Col>
        <Col>
          <Input
            label={"Position"}
            {...form.register(
              `projectMembers[${memberIndex}].members[${index}].position`
            )}
          />
        </Col>
        <Col>
          <div className="d-flex gap-3">
            <Textarea
              label={"Description"}
              {...form.register(
                `projectMembers[${memberIndex}].members[${index}].description`
              )}
            />
            <div className="mt-3 text-red cursor-pointer" onClick={onRemove}>
              <TrashIcon className="icon-md" />
            </div>
          </div>
        </Col>
      </Row>
      <hr />
    </>
  );
};

export default MemberItem;
